import React from "react";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

/**
 * Persistent banner shown to unauthenticated visitors.
 * Sits at the very top of the content area as a soft conversion nudge.
 */
export default function GuestBanner({ onSignIn }) {
  return (
    <div className="guest-banner" data-testid="guest-banner">
      <div className="guest-banner-icon" aria-hidden="true">
        <Sparkle size={16} weight="fill" />
      </div>
      <div className="guest-banner-text">
        <strong>You're exploring in trial mode.</strong>
        <span> Add conditions, draft statements, run the math — none of it saves until you create a free account.</span>
      </div>
      <button
        type="button"
        className="guest-banner-cta"
        onClick={onSignIn}
        data-testid="guest-banner-signin"
      >
        Sign in to save <ArrowRight size={13} weight="bold" />
      </button>
    </div>
  );
}
